import React from 'react';
import { InputTypeMask } from './';

const mask = [
  'h',
  't',
  't',
  'p',
  's',
  ':',
  '/',
  '/', // https://
  /[w]/,
  /[w]/,
  /[w]/,
  '.', // www.
  /[a-z]/,
  /[a-z]/,
  /[a-z]/,
  /[a-z]/,
  /[a-z]/,
  /[a-z]/,
  /[a-z]/,
  /[a-z]/,
  /[a-z]/,
  /[a-z]/,
  /[a-z]/, // domínio variável (até 12 chars)
  '.',
  /[a-z]/,
  /[a-z]/,
  /[a-z]/, // .com
  '/', // barra antes do username
  /[A-Za-z0-9_.]/,
  /[A-Za-z0-9_.]/,
  /[A-Za-z0-9_.]/,
  /[A-Za-z0-9_.]/,
  /[A-Za-z0-9_.]/, // username (até 5 chars como exemplo)
];

export default (props) => <InputTypeMask {...props} mask_={mask} />;
